import { LANG } from '../../constants/i18n';

export default {
    messages: {
        [LANG.SC]: {
            企业问答: '企业问答',
            活动时间: '活动时间',
            了解规则: '了解规则',
            查看更多问答: '查看更多问答'
        },
        [LANG.TC]: {
            企业问答: '企業問答',
            活动时间: '活動時間',
            了解规则: '了解規則',
            查看更多问答: '查看更多問答'
        },
        [LANG.EN]: {
            企业问答: 'Conference Call Q&A',
            活动时间: 'Event time',
            了解规则: 'Learn More',
            查看更多问答: 'View More'
        },
        [LANG.JA]: {
            企业问答: '決算説明会質疑応答',
            活动时间: 'イベント開催時間',
            了解规则: '詳細を見る',
            查看更多问答: 'もっと見る'
        }
    }
};
